import * as z from "zod";

import { maintenancePlanActionCreateSchema } from "./maintenance-plan-action-create";

export const maintenancePlanBulkImportFieldSchema = z.enum([
  "groupCode",
  "groupName",
  "propertyName",
  "propertyPartName",
  "propertyPartCode",
  "description",
  "cost",
  "yearlyFrequency",
  "lastAction",
]);

export type MaintenancePlanBulkImportField = z.infer<
  typeof maintenancePlanBulkImportFieldSchema
>;

export const maintenancePlanBulkImportRowSchema = z.object({
  groupCode: z.string().min(1),
  groupName: z.string().min(1),
  propertyName: z.string().min(1),
  propertyPartName: z.string().min(1),
  propertyPartCode: z.string().min(1),
  description: z.string(),
  cost: z.number().optional(),
  yearlyFrequency: z.number().optional(),
  lastAction: maintenancePlanActionCreateSchema.optional(),
});

export type MaintenancePlanBulkImportRow = z.infer<
  typeof maintenancePlanBulkImportRowSchema
>;

export const maintenancePlanBulkImportSchema = z.object({
  rows: z.array(maintenancePlanBulkImportRowSchema).min(1),
});

export type MaintenancePlanBulkImport = z.infer<
  typeof maintenancePlanBulkImportSchema
>;

export const maintenancePlanBulkImportResultSchema = z.object({
  created: z.number(),
  skipped: z.number(),
});

export type MaintenancePlanBulkImportResult = z.infer<
  typeof maintenancePlanBulkImportResultSchema
>;
